import clx from 'classnames';
import * as React from 'react';

import styled from 'styled-components';

const StyledButtonRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  position: sticky;
  bottom: 0;
  background: #fff;

  &:not(.no-divider) {
    border-top: 1px solid ${props => props.theme.colorSplit};
    padding-top: 24px;
    margin-top: 24px;
  }
`;

export interface ButtonRowProps extends React.HTMLAttributes<HTMLDivElement> {
  // Per rimuovere il bordo superiore
  removeDivider?: boolean;
}

/**
 * Container per i pulsanti Salva etc
 *
 * I pulsanti saranno posizionati a destra con un bordo superiore
 * se non viene specificato il parametro removeDivider
 */
export function ButtonRow(props: ButtonRowProps) {
  return (
    <StyledButtonRow
      {...props}
      className={clx(props.className, {
        'no-divider': props.removeDivider,
      })}
    />
  );
}
